import { render, staticRenderFns } from "./wait_confirm.vue?vue&type=template&id=0176ab68&scoped=true"
import script from "./wait_confirm.vue?vue&type=script&lang=js"
export * from "./wait_confirm.vue?vue&type=script&lang=js"
import style0 from "./wait_confirm.vue?vue&type=style&index=0&id=0176ab68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0176ab68",
  null
  
)

export default component.exports